export default __webpack_public_path__ + "static/media/h.daaf8192.mp3";